import { render, staticRenderFns } from "./RecipeModal.vue?vue&type=template&id=9a066292&scoped=true"
import script from "./RecipeModal.vue?vue&type=script&lang=js"
export * from "./RecipeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a066292",
  null
  
)

export default component.exports